import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  loader: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    aspectRatio: '16/9',
    pointerCvents: 'none',
    backgroundColor: 'var(--primary__page__background) !important',
    position: 'relative'
  },
  badge: {
    fontFamily: 'BentonSansBold',
    fontSize: '14px !important',
    height: '22px !important',
    paddingTop: '6px !important',
    margin: '20px 0px 0px 20px !important',
    textAlign: 'center',
    maxWidth: '85px'
  },
  card: {
    backgroundColor: 'var(--primary__page__background) !important',
    borderBottomLeftRadius: '0 !important'
  },
  cardBody: {
    backgroundColor: 'var(--primary__page__background) !important',
    marginBottom: '10px'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between !important'
  },
  carousel: ({ actions }) => ({
    '&:after': {
      content: "' '",
      minWidth: '20px'
    },
    display: !actions && 'none',
    padding: '15px'
  }),
  map: {
    margin: '0',
    '&:not(:last-child)': {
      paddingBottom: '10px'
    }
  },
  mediaContainer: {
    '@media (max-width: 667px)': {
      cardBody: {
        padding: '6px 16px !important'
      }
    }
  },
  scenariosCarousel: ({ customerActions }) => ({
    '&:after': {
      content: "' '",
      display: !customerActions && 'none',
      minWidth: '20px'
    },
    padding: '5px 35px 40px 15px'
  }),
  subheader: {
    display: 'flex',
    flexDirection: 'row !important',
    justifyContent: 'flex-start !important'
  },
  text: {
    marginRight: '5px'
  },
  title: {
    fontWeight: '600 !important'
  }
})

export default useStyles
